const $ = jQuery;

const accordionButtons = $('.accordions li button');

function accordionToggle() {
	$('.accordions li button').on('click', function(e) {

		const control = $(this);
		const accordionContent = control.attr('aria-controls');
		const isAriaExp = control.attr('aria-expanded');
		const newAriaExp = (isAriaExp == "false") ? "true" : "false";
		const isAriaHid = $('#' + accordionContent).attr('aria-hidden');

		control.attr('aria-expanded', newAriaExp);

		if(isAriaHid == "true") {
			$('#' + accordionContent).attr('aria-hidden', "false");
			$('#' + accordionContent).slideDown();
		} else {
			$('#' + accordionContent).attr('aria-hidden', "true");
			$('#' + accordionContent).slideUp();
		}

	});
}

accordionToggle();